import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { ProductInterface } from 'interfaces/product.interface';

import ProductActionPriceAlert from 'components/product/product-actions/product-action-price-alert';
import ProductActionPriceHistory from 'components/product/product-actions/product-action-price-history';
import ProductActionProducer from 'components/product/product-action-producer/product-action-producer';

import './product-actions.scss';

const ProductActions: React.FC<{ product: Pick<ProductInterface, 'price' | 'offers' | 'url' | 'producer' | 'id'>; }> = ({ product }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className={`product-actions${isMobile ? ' product-actions--mobile' : ''}`}>
            <div className="product-actions__list">
                { product.producer.logo?.area && (
                    <ProductActionProducer
                        src={product.producer.logo?.area}
                        name={product.producer.name}
                        url={product.producer.url}
                    />
                )}
                <ProductActionPriceAlert
                    price={product.price}
                    productId={product.id}
                />
                <ProductActionPriceHistory
                    offer={product.offers.items[0]}
                    price={product.price}
                    productUrl={product.url}
                    productId={product.id}
                />
            </div>
        </div>
    );
};

export default ProductActions;
